import { render, staticRenderFns } from "./form-constructor.vue?vue&type=template&id=6ed628c2&scoped=true&"
import script from "./form-constructor.vue?vue&type=script&lang=js&"
export * from "./form-constructor.vue?vue&type=script&lang=js&"
import style0 from "./form-constructor.vue?vue&type=style&index=0&id=6ed628c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed628c2",
  null
  
)

export default component.exports